import { motion, useReducedMotion } from 'framer-motion'
import { ease } from '../lib/motion'

// L-shaped viewfinder corners (DESIGN.md §5.1). Parent must be position:relative.
// `bright` brightens to sapphire-lit (hover/focus handled by parent CSS via .is-bright).
const CORNERS = [
  { k: 'tl', pos: { top: 0, left: 0 }, rot: 0 },
  { k: 'tr', pos: { top: 0, right: 0 }, rot: 90 },
  { k: 'br', pos: { bottom: 0, right: 0 }, rot: 180 },
  { k: 'bl', pos: { bottom: 0, left: 0 }, rot: 270 },
] as const

export function CornerBrackets({ size = 16, draw = false, delay = 0, className = '' }: { size?: number; draw?: boolean; delay?: number; className?: string }) {
  const reduced = useReducedMotion()
  const animate = draw && !reduced
  return (
    <>
      {CORNERS.map((c) => (
        <svg
          key={c.k}
          className={`bracket bracket--${c.k} ${className}`}
          width={size}
          height={size}
          viewBox="0 0 18 18"
          aria-hidden
          style={{ position: 'absolute', ...c.pos, transform: `rotate(${c.rot}deg)`, pointerEvents: 'none' }}
        >
          <motion.path
            d="M1 17 V3 a2 2 0 0 1 2 -2 H17"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            initial={animate ? { pathLength: 0, opacity: 0 } : { pathLength: 1, opacity: 1 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={{ duration: animate ? 0.22 : 0, ease: ease.out as unknown as number[], delay }}
          />
        </svg>
      ))}
    </>
  )
}
